export default __webpack_public_path__ + "static/media/mobile-icon.4f79b958.svg";